import React, { Component } from 'react'
import { LeaderDetail as LeaderDetailForm } from 'containers/forms/leaders'
import { meta } from 'helpers/decorators'
import { get } from 'lodash'

@meta({
  title: 'Leader detail'
})
class LeaderDetail extends Component {
  render() {
    return (
      <LeaderDetailForm params={get(this.props, 'match.params', {})} {...this.props} />
    )
  }
}

export default LeaderDetail
